import * as React from 'react';

import noop from 'helper/noop';

import Image, { ImageProps } from 'components/atoms/Image';

export type TableListCellProps = {
	text?: string;
	image?: ImageProps;
};

export type TableListItemProps = {
	handleClick?: Function;
	id: number;
	href?: string;
	cells?: TableListCellProps[];
};

export type TableListProps = {
	items: TableListItemProps[];
	handleClick: Function;
};

export default class TableList extends React.Component<TableListProps> {
	public static displayName = 'TableList';

	public static defaultProps = {
		handleClick: noop,
	};

	public renderCell(cell: TableListCellProps, index: number) {
		return (
			<span key={index} className="m-table-list__cell">
				{cell.text ? cell.text : ''}
				{cell.image && (
					<span className="m-table-list__thumb">
						<Image srcset={cell.image.srcset} alt={cell.image.alt} title={cell.image.title} />
					</span>
				)}
			</span>
		);
	}

	public handleClick = (itemId: number, ev: Event) => {
		ev.preventDefault();
		this.props.handleClick(itemId);
	};

	public render() {
		const _this = this;
		const { items = [], handleClick }: TableListProps = this.props;

		return (
			<ul className="m-table-list">
				{items &&
					items.length > 0 &&
					items.map((item: TableListItemProps) => {
						return (
							<li
								key={item.id}
								onClick={handleClick ? this.handleClick.bind(this, item.id as number) : ('' as any)}
								className="m-table-list__item"
							>
								<a className="m-table-list__link" href={item.href ? item.href : ''}>
									{item.cells && item.cells.length > 0 && item.cells.map(_this.renderCell)}
								</a>
							</li>
						);
					})}
			</ul>
		);
	}
}
